
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CheckoutButton extends Vue {
  @Prop() private price!: string;
}
